var _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9.599,
    x2: 12,
    y2: 14.401
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.599,
    y1: 12,
    x2: 14.401,
    y2: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.059,9.673v-3.728c0-1.012-.819-1.832-1.83-1.832-1.102,0-2.388,0-2.908,0-.039,1.251-1.059,2.254-2.319,2.254s-2.28-1.004-2.319-2.254h-2.91c-1.012,0-1.832.82-1.832,1.832v3.728c-1.285,0-2.327,1.042-2.327,2.327s1.042,2.327,2.327,2.327v3.729c0,1.012.82,1.832,1.832,1.832h2.91c.039-1.251,1.059-2.255,2.319-2.255s2.28,1.003,2.319,2.254c.523,0,1.807,0,2.907.001,1.012,0,1.831-.82,1.831-1.832v-3.729c1.285,0,2.327-1.042,2.327-2.327s-1.042-2.327-2.327-2.327Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAdd);
export default __webpack_public_path__ + "static/media/product-add.5b68e8cef9cba6026e407b86e47fefe8.svg";
export { ForwardRef as ReactComponent };